<template>
    <v-footer
        app
        absolute
        inset
        height="200"
        class="dsp-footer white">
        <v-container>
            <v-row justify="center">
                <dsp-logo></dsp-logo>
            </v-row>
            <v-row justify="center">
                <v-col cols="10" align="center">
                    <p class="dsp-footer__about ma-0 mt-2">DSPolitical, an <a href="https://www.winwithoptimal.com/?utm_source=2022WinSite&utm_medium=Website&utm_campaign=WEB_FooterAnOptimalCompany" target="_blank">Optimal</a> Company, is the world’s leading voter targeted digital ad network having delivered billions of voter targeted digital ads online, to mobile devices, and Connected TV. The company pioneers the best integration of data and technology to persuade audiences and deliver wins for progressive candidates, causes, and issues with the most efficient and effective digital advertising campaigns in politics. <a href="https://www.dspolitical.com/about-us/?utm_source=2022WinSite&utm_medium=Website&utm_campaign=WEB_FooterLearnMore" target="_blank">Learn more</a>.</p>
                </v-col>
            </v-row>
            <v-row 
                align="center"
                justify="center">
                <v-col 
                    sm="4"
                    offset-sm="0">
                    <v-row justify="center">
                        <v-btn 
                            class="dsp-button"
                            color="secondary"
                            depressed
                            large
                            rounded
                            href="https://www.dspolitical.com/?utm_source=2022WinSite&utm_medium=Website&utm_campaign=WEB_FooterLearnMore#work-with-us"
                            target="_blank">
                            Learn More
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center" class="mt-10">
                <p class="dsp-footer__copyright">Last Updated: Dec 13, 2024</p>
            </v-row>
            <v-row justify="center">
                <p class="dsp-footer__copyright">© 2011-2024 <a href="https://www.dspolitical.com/" target="_blank">DSPolitical, LLC</a> | <a href="https://www.dspolitical.com/privacy-policy/" target="_blank">Privacy Policy</a></p>
            </v-row>
            <v-row justify="center">
                <v-col cols="10" md="9">
                    <narrative-disclaimer></narrative-disclaimer>
                </v-col>
            </v-row>
        </v-container>
    </v-footer>
</template>
<script>
import dspLogo from './dspLogo.vue';
import NarrativeDisclaimer from "@/components/narrative/NarrativeDisclaimer.vue";
export default {
    name: 'dspFooter',
    components: { NarrativeDisclaimer, dspLogo }
}
</script>
<style lang="scss">
    @import "../styles/_variables.scss";
    .dsp-footer{
        border-top: 1px solid gray;
        &__about{
            font-size: 12px;
        }
        &__copyright{
            font-size: 12px;
            a{
                text-decoration: none;
                color: inherit;
                &:hover{
                    color: $secondary;
                }
            }
        }
    }
</style>
